import React from 'react';

export const Mute: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='var(--primary-accent)'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    ></path>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M11.18 7.06l.3-.24a.323.323 0 01.448.044.306.306 0 01.072.197v9.878c0 .172-.142.31-.318.311a.323.323 0 01-.202-.07l-.3-.24v-.001l-.311-.248-.036-.028-2.721-2.176H5.635A.63.63 0 015 13.865v-3.73a.63.63 0 01.636-.622h2.475l2.722-2.176.037-.029.31-.247zm-2.34 3.365l1.993-1.594v6.338L8.84 13.575l-.32-.255H6.167v-2.64H8.52l.319-.255zm9.747 3.246L16.917 12l1.67-1.671a.588.588 0 00-.833-.833l-1.67 1.67-1.672-1.67a.588.588 0 00-.829.004.588.588 0 00-.004.829L15.25 12l-1.67 1.671a.588.588 0 00.003.83.588.588 0 00.83.003l1.67-1.67 1.671 1.67a.588.588 0 00.833-.833z'
      clipRule='evenodd'
    ></path>
  </svg>
);
